import { ApiUtility, HttpMethods } from "../Utilities/ApiUtility.axios";

export interface IXcelifyAdminListItem {
  id: string;
  sno?: number;
  practiceId: number;
  number: string;
  autoNumber: number;
  company?: { id: string; name: string };
  bank?: { id: string; name: string };
  file?: {
    id: string;
    name: string;
    path: string;
    contentType: string;
    length: number;
  };
  createdBy?: {
    userId: string;
    userName: string;
    date: string;
  };
}

export interface IXcelifyItemKey {
  id: string;
  practiceId: number;
}

export interface IIdNameOption {
  id: string;
  name: string;
}

export interface IExtractionProgressInfo {
  jobId: string;
  total: number;
  processed: number;
  percent: number;
  status: string;
}

class XcelifyExtractionService {
  route = "/api/Admin/Xcelify";

  getList = (start: number, length: number, search?: string, practiceId: number = 0, clientId?: string, bankId?: string) =>
    ApiUtility.getResult(`${this.route}/List`, {
      start,
      length,
      search,
      practiceId,
      clientId,
      bankId,
    });

  getCompaniesByPractice = (practiceId: number) =>
    ApiUtility.getResult<IIdNameOption[]>(`${this.route}/Companies`, {
      practiceId,
    });

  getBanksByPractice = (practiceId: number) =>
    ApiUtility.getResult<IIdNameOption[]>(`${this.route}/Banks`, {
      practiceId,
    });

  getProgress = (jobId: string) =>
    ApiUtility.getResult<IExtractionProgressInfo>(`${this.route}/Progress/${jobId}`);

  cancelProgress = (jobId: string) =>
    ApiUtility.post(`${this.route}/CancelProgress/${jobId}`, {});

  downloadSingle = (id: string, practiceId: number = 0) =>
    ApiUtility.downloadFile(`${this.route}/DownloadSingle/${id}`, { practiceId }, HttpMethods.get);

  extractBulk = (
    items: IXcelifyItemKey[],
    extractAll: boolean = false,
    practiceId: number = 0,
    clientId?: string,
    bankId?: string,
    search?: string,
    jobId?: string
  ) =>
    ApiUtility.downloadFile(
      `${this.route}/ExtractBulk`,
      { items, extractAll, practiceId, clientId, bankId, search, jobId },
      HttpMethods.post
    );

  downloadFiles = (ids: string, practiceId: number = 0) =>
    ApiUtility.downloadFile(`${this.route}/DownloadFiles`, { ids, practiceId }, HttpMethods.get);
}

export default new XcelifyExtractionService();
